import { render, staticRenderFns } from "./JobDetailsForm.vue?vue&type=template&id=20d3d10c&"
import script from "./JobDetailsForm.vue?vue&type=script&lang=js&"
export * from "./JobDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./JobDetailsForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports